export default {
  imageBox: {
    width: 120,
    height: 120,
    border: '2px solid'
  }
};



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/ImageUploadButton/ImageUploadButton.css.js